// extracted by mini-css-extract-plugin
export default {"simulatorInputWrapper":"styles_simulatorInputWrapper__xT4bA","instructions":"styles_instructions__R1ms+","feedback":"styles_feedback__yKgmj","popover":"styles_popover__NegWA"};